import type { PortalAudience } from '@/access/portalAccess.types';
import type { DashboardViewInput } from '@/modules/dashboard/dashboard.viewInput';

export type DashboardJobsQueryType = 'tenantByDateRange';

export type DashboardView = {
  audience: PortalAudience;
  widgets: {
    showHeader: boolean;
    showJobsSummary: boolean;
    showTodaysJobs: boolean;
    showTimesheetDisputes: boolean;
    showUnfilledJobs: boolean;
    showNoJobsSection: boolean;
  };
  query: {
    clients: { fetch: boolean };
    workers: { fetch: boolean };
    daySequencesRequiringAction: { fetch: boolean };
    jobs: {
      strategy: DashboardJobsQueryType;
    };
  };
};

export const getDashboardView = ({
  access,
}: DashboardViewInput): DashboardView => {
  const { audience } = access;

  // Encode current tenant dashboard behavior for all tenant roles.
  // Role-specific widget branching can be added here later if needed.
  return {
    audience,
    widgets: {
      showHeader: true,
      showJobsSummary: true,
      showTodaysJobs: true,
      showTimesheetDisputes: true,
      showUnfilledJobs: true,
      showNoJobsSection: true,
    },
    query: {
      clients: { fetch: true },
      workers: { fetch: true },
      daySequencesRequiringAction: { fetch: true },
      jobs: {
        strategy: 'tenantByDateRange',
      },
    },
  };
};
